import { NameIdOption } from "../../../../../common/types/commonTypes";

type CompanyOnlyRuleCheckValues = {
  customerOrganization: NameIdOption | null;
  workLocations: NameIdOption[];
  workTitles: NameIdOption[];
};

export const isCompanyOnlyRule = (
  values: CompanyOnlyRuleCheckValues,
): boolean =>
  !values.customerOrganization &&
  (values.workLocations ?? []).length === 0 &&
  (values.workTitles ?? []).length === 0;
